/**
 * step-chip.js
 */

import React from 'react';
import { Chip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Icon from 'components/icon';


const useStyles = makeStyles(theme => ({
  chip: {
    marginRight: theme.spacing(2),
    '&.edit': {
      '& .MuiChip-icon': {
        width: 17,
        height: 17,
        marginLeft: 5,
        marginRight: -5,
        marginTop: -2
      }
    },
    '& .MuiChip-label': {
      paddingRight: theme.spacing(1)
    },
    [theme.breakpoints.down('sm_md')]: {
      marginRight: theme.spacing(1.5),
    }
  }
}));


export default function StepChip(props) {
  const {
    step,
    state, // edit|incomplete|complete
  } = props;
  const classes = useStyles();


  return (
    <>
      <Chip 
        size="small" 
        className={`${classes.chip} ${state} chip-${state} chip-font-${state}`}
        icon={<Icon type={state} className={`chip-font-${state}`}/>}
        label={`Step ${step}`}
      />
    </>
  );
}